/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SyllabusLocale = "EN_AU" | "EN_GB" | "EN_US" | "ES" | "FR" | "HT_HT" | "PT";
export type FreeTextbookJsxLessonContainer_subtopic = {
    readonly rslJsx: {
        readonly id: string | null;
        readonly pdfAvailable: boolean;
        readonly pdfUrl: string | null;
        readonly transpiledJsx: string | null;
        readonly locale: SyllabusLocale | null;
    };
    readonly rslTeacherNoteJsx: {
        readonly id: string | null;
        readonly transpiledJsx: string | null;
        readonly locale: SyllabusLocale | null;
    };
    readonly investigationJsx: {
        readonly id: string | null;
        readonly transpiledJsx: string | null;
        readonly locale: SyllabusLocale | null;
    };
    readonly investigationTeacherNoteJsx: {
        readonly id: string | null;
        readonly transpiledJsx: string | null;
        readonly locale: SyllabusLocale | null;
    };
    readonly solidifyLessonJsx: {
        readonly id: string | null;
        readonly pdfAvailable: boolean;
        readonly transpiledJsx: string | null;
        readonly pdfUrl: string | null;
    };
    readonly solidifyTeacherNoteJsx: {
        readonly transpiledJsx: string | null;
        readonly pdfAvailable: boolean;
        readonly pdfUrl: string | null;
    };
    readonly " $refType": "FreeTextbookJsxLessonContainer_subtopic";
};
export type FreeTextbookJsxLessonContainer_subtopic$data = FreeTextbookJsxLessonContainer_subtopic;
export type FreeTextbookJsxLessonContainer_subtopic$key = {
    readonly " $data"?: FreeTextbookJsxLessonContainer_subtopic$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"FreeTextbookJsxLessonContainer_subtopic">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdfAvailable",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdfUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transpiledJsx",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locale",
  "storageKey": null
},
v5 = [
  (v0/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FreeTextbookJsxLessonContainer_subtopic",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RetrofittedStudentLesson",
      "kind": "LinkedField",
      "name": "rslJsx",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RetrofittedStudentLessonTeacherNote",
      "kind": "LinkedField",
      "name": "rslTeacherNoteJsx",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Investigation",
      "kind": "LinkedField",
      "name": "investigationJsx",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InvestigationTeacherNote",
      "kind": "LinkedField",
      "name": "investigationTeacherNoteJsx",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SolidifyLesson",
      "kind": "LinkedField",
      "name": "solidifyLessonJsx",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v3/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SolidifyTeacherNote",
      "kind": "LinkedField",
      "name": "solidifyTeacherNoteJsx",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "FreeTextbookSubtopic",
  "abstractKey": null
};
})();
(node as any).hash = '73a4c81a659ff34f900a4752bae6aa0a';
export default node;
